<template>
  <a-modal
    :title="title"
    width="40%"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :maskClosable="false"
    :keyboard="false"
    @cancel="handleCancel"
    @ok="submit"
    ok-text="保存"
    cancel-text="取消"
    :destroyOnClose="true"
  >
    <div>
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="年份" prop="addYear">
          <a-date-picker
            placeholder="请选择年份"
            v-model="form.addYear"
            :open="yearShowOne"
            :locale="locale"
            :format="'YYYY'"
            mode="year"
            @openChange="openChangeOne"
            @panelChange="panelChangeOne"
            @change="handleClearAcquireYear"
            style="width: 100%"
            :disabled="disabeld"
          />
        </a-form-model-item>
        <a-form-model-item label="名称" prop="award">
          <a-input
            v-model="form.award"
            placeholder="请输入名称"
            :disabled="disabeld"
          />
        </a-form-model-item>
        <a-form-model-item label="类别" prop="type">
          <div class="flex">
            <a-select
              v-model="form.type"
              placeholder="请选择类别"
              :disabled="disabeld"
            >
              <a-select-option
                :value="item.text"
                v-for="item in jxlist"
                :key="item.value"
                >{{ item.title }}</a-select-option
              >
              <a-select-option value="其他">其他</a-select-option>
            </a-select>
            <template v-if="form.type == '其他'">
              <a-input v-model="form.otherType" class="ipt-other" :disabled="disabeld" />
            </template>
          </div>
        </a-form-model-item>
        <a-form-model-item label="个数/次数" prop="num">
          <a-input-number
            v-model="form.num"
            min="1"
            precision="0"
            style="width: 100%"
            placeholder="请输入个数"
            :disabled="disabeld"
          />
        </a-form-model-item>
        <template v-if="form.type === '教学成果奖取得数量（国家级、省级）'">
          <a-form-model-item label="成果名称" prop="awardName">
            <a-input
              v-model="form.awardName"
              placeholder="请输入名称"
              :disabled="disabeld"
            />
          </a-form-model-item>
          <a-form-model-item label="级别" prop="achievementLevel">
            <a-select
              v-model="form.achievementLevel"
              placeholder="请选择类别"
              :disabled="disabeld"
            >
              <a-select-option
                :value="item.text"
                v-for="item in levelList"
                :key="item.value"
                >{{ item.title }}</a-select-option
              >
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="时间" prop="awardTime">
            <a-date-picker
              v-model="form.awardTime"
              :locale="locale"
              style="width: 100%"
              :disabled="disabeld"
            />
          </a-form-model-item>
        </template>
      </a-form-model>
    </div>
  </a-modal>
</template>
    
  <script>
import { getAction, postAction, putAction } from "@/api/index";
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
import BaseEditor from "@/components/common/BaseEditor.vue";
moment.locale("zh-cn");
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
      other: "",
      form: {
        applyId: "",
        addYear: "",
        type: "",
        num: "",
        award: "",
        otherType: "",
        awardTime: "",
        achievementLevel: "",
        awardName: "",
      },
      rules: {
        addYear: [
          {
            required: true,
            message: "请选择年份",
            //          type: 'string',
            trigger: "change",
          },
        ],
        award: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur",
          },
        ],
        type: [
          {
            required: true,
            message: "请选择类别",
            trigger: "change",
          },
        ],
        num: [
          {
            required: true,
            message: "请输入个数",
            trigger: "blur",
          },
        ],
        awardTime: [
          {
            required: true,
            message: "请选择时间",
            //          type: 'string',
            trigger: "change",
          },
        ],
        awardName: [
          {
            required: true,
            message: "请输入成果名称",
            trigger: "blur",
          },
        ],
        achievementLevel: [
          {
            required: true,
            message: "请选择级别",
            trigger: "change",
          },
        ],
      },
      yearShowOne: false,
      zh_CN,
      locale,
      applyType: 2,
      // 添加还是编辑
      type: "",
      // 弹框标题
      title: "",
      xwlist: [],
      jblist: [],
      kclist: [],
      ishow: false,
      ifirst: true,
      jxlist: [],
      levelList: [],
      disabeld: false,
    };
  },
  components: { BaseEditor },
  methods: {
    openChangeOne(status) {
      if (status) {
        this.yearShowOne = true;
      }
    },
    handleClearAcquireYear() {
      //  	console.log("111111");
      this.form.addYear = ""; // 或者适当的空值，根据你的业务需求
      this.$forceUpdate();
    },
    panelChangeOne(value) {
      //   	      console.log(value,"111111");
      // this.form.addYear = value;
      const year = moment(value).format("YYYY");
      this.form.addYear = year + "";
      this.yearShowOne = false;
      this.$refs.ruleForm.clearValidate("addYear");
      // this.yearShowOne = false;
    },
    init(type, record) {
      this.type = type;
      this.visible = true;
      this.getxwlist();
      this.getcgjb();
      this.getkclist();
      this.getJxList();
      this.getLevelList();
      if (type == "add") {
        this.form = {};
        this.form.applyId = record.id;
        this.form.addYear = new Date().getFullYear() + "";
        this.title = "新增品牌效果";
      } else if (type == "edit") {
        this.title = "编辑品牌效果";
        this.form = {
          id: record.id,
          applyId: record.applyId,
          addYear: record.addYear,
          type: record.type,
          num: record.num,
          award: record.award,
          otherType: record.otherType,
          awardTime: record.awardTime,
          achievementLevel: record.achievementLevel,
          awardName: record.awardName,
        };
      } else {
        this.disabeld = true;
        this.title = "查看品牌效果";
        this.form = {
          id: record.id,
          applyId: record.applyId,
          addYear: record.addYear,
          type: record.type,
          num: record.num,
          award: record.award,
          otherType: record.otherType,
          awardTime: record.awardTime,
          achievementLevel: record.achievementLevel,
          awardName: record.awardName,
        };
      }
    },
    handleCancel() {
      this.visible = false;
      //     this.yearShowOne = false;
    },
    getLevelList() {
      getAction("/baseCommon/getDictItemsByCode?code=achievement_level").then(
        (res) => {
          if (res.code == 200) {
            this.levelList = res.result;
          }
        }
      );
    },
    getJxList() {
      getAction("/baseCommon/getDictItemsByCode?code=brand_effect").then(
        (res) => {
          if (res.code == 200) {
            this.jxlist = res.result;
          }
        }
      );
    },
    getxwlist(ids) {
      getAction("/baseCommon/getDictItemsByCode?code=achievement_type").then(
        (res) => {
          if (res.code == 200) {
            this.xwlist = res.result;
          }
        }
      );
    },
    getcgjb() {
      this.jblist = [
        {
          value: "1",
          title: "国家级",
        },
        {
          value: "2",
          title: "省级",
        },
        {
          value: "3",
          title: "市级",
        },
        {
          value: "4",
          title: "县级",
        },
        {
          value: "5",
          title: "校级",
        },
        {
          value: "其他",
          title: "其他",
        },
      ];
      // getAction("/baseCommon/getDictItemsByCode?code=achievement_level",).then((res) => {
      // 	if (res.code == 200) {
      // 		this.jblist=res.result;
      // 	}
      // });
    },
    getkclist() {
      getAction("/baseCommon/getDictItemsByCode?code=apply_course_type").then(
        (res) => {
          if (res.code == 200) {
            this.kclist = res.result;
          }
        }
      );
    },
    submit() {
      //  	this.$refs.ruleForm.clearValidate();
      console.log(typeof this.form.addYear);
      if (
        typeof this.form.addYear == "object" &&
        this.form.addYear != "" &&
        this.type == "add"
      ) {
        this.form.addYear = new Date(this.form.addYear).getFullYear() + "";
      }
      this.$refs.ruleForm.validate((valid) => {
        //    	console.log(valid);
        if (valid) {
          //					this.yearShowOne = false;
          if (this.type == "add") {
            let params = {
              ...this.form,
              awardTime: moment(this.form.awardTime).format("YYYY-MM-DD"),
            };
            //          params.addYear=new Date(this.form.addYear).getFullYear()+"";
            params.applyType = this.applyType;
            //params.applyId = "1829722136428707841";
            this.visible = false;
            this.$message.success("添加成功");
            this.$emit("addEffect", { record: params, type: "add" });
            // postAction("/effect/add", params).then((res) => {
            //   if (res.code == 200) {
            //     this.visible = false;
            //     this.$message.success("添加成功");
            //     this.$emit("addEffect");
            //   } else {
            //     this.$message.error(res.message);
            //   }
            // });
          } else {
            let params = this.form;
            //params.applyId = "1829722136428707841";
            if (typeof this.form.addYear == "object") {
              params.addYear = new Date(this.form.addYear).getFullYear() + "";
            }
            params.applyType = this.applyType;
            this.visible = false;
            this.$message.success("编辑成功");
            this.$emit("addEffect", { record: params, type: "edit" });
            // putAction("/effect/edit", params).then((res) => {
            //   if (res.code == 200) {
            //     this.visible = false;
            //     this.$message.success("编辑成功");
            //     this.$emit("addEffect");
            //   } else {
            //     this.$message.error(res.message);
            //   }
            // });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
/deep/ .ant-modal-title {
  text-align: center;
}
/deep/ .ant-input-number-handler-wrap {
  display: none;
}
.ipt-other {
  margin-left: 12px;
}
</style>
  